import { Column } from '~components/table-view-v3';

export const columns: Column[] = [
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'reconciliations_count',
    header: 'Reconciliations Count',
    type: 'text',
  },
  {
    id: 'reconciliation_items_count',
    header: 'Reconciliation Items Count',
    type: 'text',
  },
  {
    id: 'sum_claimed',
    header: 'Sum Claimed',
    type: 'currency',
  },
  {
    id: 'sum_government_contribution',
    header: 'Sum of Govt Contribution',
    type: 'currency',
  },
  {
    id: 'sum_co_contribution',
    header: 'Sum of Co-Contribution',
    type: 'currency',
  },
  {
    id: 'sum_total',
    header: 'Sum Paid',
    type: 'currency',
  },
];
